import { Icon, type IconProps } from "@chakra-ui/icon";

const BrandFlag = (props: IconProps) => {
	return (
		<Icon
			viewBox="0 0 15 19"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
			{...props}
		>
			<path
				d="M4.15266e-06 1.66402C0.000673554 1.45164 0.0820314 1.23946 0.244078 1.07741C0.244078 1.07741 0.207446 1.10914 0.282742 1.04069C0.299379 1.02557 0.319818 1.00772 0.344267 0.987584C0.393193 0.947293 0.458015 0.897976 0.540354 0.843083C0.705334 0.733096 0.938796 0.601954 1.25301 0.476269C1.88291 0.22431 2.82274 0 4.16667 0C5.57787 0 6.74725 0.467904 7.76307 0.874362L7.80949 0.892936C8.86624 1.31563 9.76609 1.66667 10.8333 1.66667C11.9894 1.66667 12.7162 1.47431 13.128 1.3096C13.3346 1.22695 13.4658 1.14976 13.5351 1.1035C13.5696 1.08053 13.5894 1.06484 13.596 1.05938C13.9226 0.752089 14.4366 0.758099 14.7559 1.07741C14.9186 1.24013 15 1.4534 15 1.66667V11.6659C15.0002 11.8794 14.9188 12.093 14.7559 12.2559L14.755 12.2568C14.7235 12.2882 14.6901 12.3175 14.6557 12.3457C14.6068 12.386 14.542 12.4354 14.4596 12.4903C14.2947 12.6002 14.0612 12.7314 13.747 12.8571C13.1171 13.109 12.1773 13.3333 10.8333 13.3333C9.42213 13.3333 8.25275 12.8654 7.23694 12.459L7.19051 12.4404C6.13376 12.0177 5.23391 11.6667 4.16667 11.6667C3.0106 11.6667 2.28376 11.859 1.87199 12.0237C1.79269 12.0555 1.72451 12.0864 1.66667 12.115L1.66667 17.5C1.66667 17.9602 1.29357 18.3333 0.833334 18.3333C0.373097 18.3333 0 17.9602 0 17.5L1.29232e-08 11.6669C1.29232e-08 11.6669 1.29232e-08 11.6669 1.29232e-08 11.6669L0 1.66667C1.43336e-07 1.66583 1.52756e-06 1.66486 4.15266e-06 1.66402Z"
				fill="currentColor"
			/>
		</Icon>
	);
};

export default BrandFlag;
